import { render, staticRenderFns } from "./CardProgress.vue?vue&type=template&id=22686614"
import script from "./CardProgress.vue?vue&type=script&lang=js"
export * from "./CardProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider: require('/app/components/RangeSlider.vue').default})
